import * as React from 'react';
import Div from './Div.styled';
import {CSSObject} from 'styled-components';

export interface ICustomSwitchProps {
  checked: boolean;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  labelLeft?: string;
  labelRight?: string;
  customStyle?: CSSObject;
  name?: string;
}

export default function CustomSwitch({
  name,
  checked,
  onChange,
  labelLeft,
  labelRight,
  customStyle,
}: ICustomSwitchProps) {
  return (
    <Div className="switch" customStyles={customStyle}>
      <label>
        {labelLeft}
        <input
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="slider"></span>
        {labelRight}
      </label>
    </Div>
  );
}
